import {
  ApiOutlined,
  EuroOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { Button, Col, Form, Popover, Row } from 'antd';
import { FilterConfig, FilterValues } from 'types';
import React, { useCallback, useContext, useEffect, useState } from 'react';

import { AuthContext } from 'components/Auth/Auth';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import ContractDetail from './ContractDetail';
import DataGrid from 'components/theme_components/DataGrid';
import DisplayFramework from 'DisplayFramework';
import ExportXLS from 'components/theme_components/ExportXLS';
import { FormInstance } from 'antd/lib/form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import HeroTitle from 'components/theme_components/HeroTitle';
import { InvoiceWizardMain } from 'pages/SupplierInvoice/ManualInvoiceWizard';
import ModalSFS from 'components/theme_components/ModalSFS';
import PaymentModal from './Modals/PaymentModal';
import { findFinCTByAnyRefOrStatusOrDate } from 'services/fincontract';
import { findSIByAnyRefOrStatusOrDate } from 'services/supplierInvoice';
import { getThirdPartyById } from 'services/thirdParty';
import { toCurrency } from 'utils/utils';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';

export type ContractSubTabProps = {
  form: FormInstance;

  color?: string;

  tptype?: string;

  tpauthid: number;

  tpid?: number;

  itemsCompanyHierarchyTree: any[];

  isActive?: boolean; // New prop to track if tab is active

  onTabActivated?: () => void; // Callback when tab becomes active
};

const ContractSubTab = (props: ContractSubTabProps) => {
  const {
    form,

    color,

    tptype,

    tpauthid,

    tpid,

    itemsCompanyHierarchyTree,

    isActive,

    onTabActivated,
  } = props;

  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const [selectedContract, setSelectedContract] = useState<any>(null);

  const [showContractDetail, setShowContractDetail] = useState(false);

  const rowCount = selectedRows.length;

  const [isVisible, setVisible] = useState(false);

  const [modalVisibleConfirm, setmodalVisibleConfirmVisible] = useState(false);

  const navigate = useNavigate();

  const { isInspect } = useContext(AuthContext);

  const { data: thirdPartyData } = useQuery(
    ['thirdParty', tpid],

    () => getThirdPartyById({ tpid: tpid! }),

    {
      enabled: Boolean(tpid && tpid !== 0),

      select: (response) => response.data,
    }
  );

  useEffect(() => {
    if (thirdPartyData?.generalData?.tpreference) {
      form.setFieldsValue({
        codeClient: thirdPartyData.generalData.tpreference,
      });
    }
  }, [thirdPartyData, form]);

  const useContracts = (searchParams: any, ctPhase: string) => {
    const searchs = true; // Define searchs variable

    const lphase = ctPhase; // Use ctPhase as lphase

    const initSearchParams = tpid
      ? { ...searchParams, tpid: tpid }
      : searchParams;

    const proposalQuery = useQuery(['proposalQuery', initSearchParams], () =>
      Promise.resolve([])
    ); // Define proposalQuery

    const fincontractQuery = useQuery(
      ['findFinCTByAnyRefOrStatusOrDate', initSearchParams],

      () =>
        findFinCTByAnyRefOrStatusOrDate(initSearchParams).then(
          (res) => res.list
        ),

      { enabled: searchs && lphase === 'PROD' }
    );

    return lphase === 'PROPOSAL' ? proposalQuery : fincontractQuery;
  };

  const handleInvoiceClick = async (siinvoice: string) => {
    try {
      console.log('🔍 Recherche facture:', siinvoice);

      const response = await findSIByAnyRefOrStatusOrDate({
        sireference: siinvoice,

        mgid: 1,
      });

      if (response.list && response.list.length > 0) {
        const invoice = response.list[0];

        if (invoice.siid) {
          navigate(`/supplier-invoice/${invoice.siid}`);
        } else {
          console.warn(' Pas de siid dans la facture');
        }
      } else {
        console.warn(' Aucune facture trouvée pour:', siinvoice);
      }
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const [filterForm] = Form.useForm();

  const filterConfig: FilterConfig[] = [
    {
      key: 'PRCODE',

      label: 'prcode',

      type: 'select',
    },

    {
      key: 'siinvoice',

      label: 'siinvoice',

      type: 'text',
    },

    {
      key: 'vin',

      label: 'vin',

      type: 'text',
    },

    {
      key: 'datemin',

      label: 'ctestartdate',

      type: 'date',
    },

    {
      key: 'ctreference',

      label: 'ctreference',

      type: 'text',
    },

    {
      key: 'minremaining',

      label: 'minremaining',

      type: 'text',
    },

    {
      key: 'maxremaining',

      label: 'Restant max',

      type: 'text',
    },
  ];

  const [searchParams, setSearchParams] = useState({});

  const {
    data: fincontractData,

    isFetching,

    refetch,
  } = useContracts(searchParams, 'PROD');

  const handleFilterSearch = useCallback(
    (values: FilterValues) => {
      const formattedValues = {
        ...values,

        datemin: values.datemin ? values.datemin.format('YYYY-MM-DD') : '',
      };

      setSearchParams(formattedValues);

      refetch();
    },

    [refetch]
  );

  const handleFilterReset = useCallback(() => {
    filterForm.resetFields();

    setSearchParams({});

    refetch();
  }, [filterForm, refetch]);

  // Effect to handle tab activation

  useEffect(() => {
    if (isActive) {
      // Refetch data when tab becomes active

      refetch();

      onTabActivated?.();
    }
  }, [isActive, refetch, onTabActivated]);

  useEffect(() => {
    filterForm.setFieldsValue({ filteredData: fincontractData });
  }, [filterForm, fincontractData, selectedContract]);

  const columns = [
    {
      dataIndex: 'ctcomment',

      key: 'ctcomment',

      width: '40px',

      render: (val: string, record: any) => {
        return val ? (
          <span>
            <Popover
              content={val}
              title={<GetLabel label="comment" />}
              trigger="hover"
              placement="bottom"
            >
              
            </Popover>
          </span>
        ) : null;
      },
    },

    {
      dataIndex: 'siinvoice',

      key: 'siinvoice',

      render: (siinvoice: string) => (
        <span
          style={{
            color: '#1890ff',

            cursor: 'pointer',

            textDecoration: 'underline',
          }}
          onClick={() => siinvoice && handleInvoiceClick(siinvoice)}
        >
          {siinvoice || '-'}
        </span>
      ),
    },

    {
      dataIndex: 'vin1',

      key: 'vin1',
    },

    {
      dataIndex: 'vin2',

      key: 'vin2',
    },

    {
      dataIndex: 'ctreference',

      key: 'ctreference',
    },

    {
      dataIndex: 'prcode',

      key: 'prcode',
    },

    {
      dataIndex: 'ctestartdate',

      key: 'ctestartdate',
    },

    {
      dataIndex: 'statuslabel',

      key: 'statuslabel',
    },

    {
      dataIndex: 'cteduration',

      key: 'cteduration',
    },

    {
      dataIndex: 'ctfinancedamount',

      key: 'ctfinancedamount',

      render: (val: number, record: any) => {
        return toCurrency(val);
      },
    },

    {
      dataIndex: "ctfinancedamount",
 
      comcode: "ctremainingamount",
 
      render: (value: number, record: any) => {
        const displayAmount = record.ctstatus === "CANCEL" ? 0 : value
        return <>{toCurrency(displayAmount)}</>
      },
    },

    {
      key: 'arrow',

      width: '70px',

      render: (_: any, record: any) => (
        <RightOutlined
          onClick={() => navigate(`/activity-sfs/${record.ctrid}`)}
        />
      ),
    },
  ];

  const Activitycolumns = [
    {
      title: 'RRDI',
      dataIndex: 'clientreference',
      key: 'clientreference',
    },

     {
      dataIndex: 'clientname',
      key: 'clientname',
      width: '250px',
    },

    {
      title: 'Brand',
      key: 'brand',
      render: (_: any, record: any) => {
        return record.authbrand || record.ctnetworkcodelabel || '-';
      },
    },
    

    {
      dataIndex: 'siinvoice',
      key: 'siinvoice',
    },

    {
      title: 'VIN1 & VIN2 (VIS)',

      key: 'vin_combined',

      render: (record: any) => {
        const vin1 = record.vin1 || '';

        const vin2 = record.vin2 || '';

        return `${vin1}${vin2}`;
      },
      width: '200px',
    },

    {
      title: 'Contract Number',

      dataIndex: 'ctreference',

      key: 'ctreference',
    },

    {
      title: 'Product Family',

      dataIndex: 'prcodelabel',

      key: 'prcodelabel',
    },

    {
      title: 'Contract Start Date',

      dataIndex: 'ctestartdate',

      key: 'ctestartdate',
    },

    {
      title: 'Status',
      dataIndex: 'statuslabel',
      key: 'statuslabel',
    },

    {
      dataIndex: 'cteduration',
      key: 'cteduration',
    },

    {
      title: 'Initial Contract Amount (€)',

      dataIndex: 'ctfinancedamount',

      key: 'ctfinancedamount',

      render: (val: number) => {
        return toCurrency(val);
      },
    },

    {
      title: 'Remaining Amount (€)',

      key: 'remaining_amount',

      render: (record: any) => {
        const remainingAmount = record.ctstatus === "CANCEL" ? 0 : record.ctfinancedamount || 0
        return toCurrency(remainingAmount);
      },
    },

    {
      title: 'Comment',
      dataIndex: 'ctcomment',
      key: 'ctcomment',

      render: (val: string, record: any) => {
        return val ? (
          <span>
            <Popover
              content={val}
              title={<GetLabel label="comment" />}
              trigger="hover"
              placement="bottom"
            >
              <InfoCircleOutlined
                style={{ cursor: 'pointer' }}
                className="color-blue font-size-18 bold"
              />
            </Popover>
          </span>
        ) : null;
      },
    },

    {
      key: 'arrow',
      width: '70px',
      render: (_: any, record: any) => (
        <RightOutlined
          onClick={() => navigate(`/activity-sfs/${record.ctrid}`)}
        />
      ),
    },
  ];

  const colsXLS = [
    'siinvoice',

    'vin1',

    'vin2',

    'ctreference',

    'prcode',

    'ctestartdate',

    'ctprefinperiod',

    'ctnextstartperiod',

    'cteduration',

    'ctfinancedamount',

    'ctremainingamount',
  ];

  const back = () => {
    setShowContractDetail(false);
  };

  return (
    <DisplayFramework.Provider pagcode="outstandingsfs">
      <Form form={form} className="bg-color-gray">
        {!showContractDetail ? (
          <>
            <div className="bg-color-gray">
              <HeroTitle
                form={filterForm}
                color={props.color || 'purple'}
                title="Encours"
                showFilter
                display
                filterConfig={filterConfig}
                onFilterSearch={handleFilterSearch}
                onFilterReset={handleFilterReset}
                className="productlist"
                noTitleOverlay
                itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
              />
            </div>

            <div className="ut-title-page no-after">
              <Row justify="space-between" align="middle" className="mb-4 mt-6">
                {tptype === 'CONC' || !tptype ? (
                  <Row gutter={24} align="middle">
                    <Col span={12}>
                      <ModalSFS
                        trigger={({ setVisible }) => (
                          <Button
                            className={
                              rowCount !== 0
                                ? 'no-border-radius filter-item ant-btn-outline-primary bg-color-hover'
                                : 'no-border-radius filter-item'
                            }
                            onClick={() => !isInspect && setVisible(true)}
                            disabled={!isInspect}
                            icon={<EuroOutlined />}
                          >
                            <GetLabel label={'progPayment'} />
                          </Button>
                        )}
                        title="progPayment"
                      >
                        <PaymentModal
                          mode="create"
                          source="encours"
                          data={selectedRows}
                          setVisible={() => setVisible(false)}
                          setmodalVisibleConfirmVisible={() =>
                            setmodalVisibleConfirmVisible(true)
                          }
                        />
                      </ModalSFS>
                    </Col>

                    <Col span={12}>
                      <ModalSFS
                        width="fit-content"
                        modalProps={{
                          style: {
                            maxWidth: '90vw',

                            minWidth: '600px',
                          },
                        }}
                        trigger={({ setVisible }) => (
                          <Button
                            className="no-border-radius ant-btn-outline-primary ml-2 filter-item ant-btn-add bg-color-hover"
                            onClick={() => !isInspect && setVisible(true)}
                            variant="outlined"
                            type="primary"
                            icon={
                              isInspect ? (
                                <ApiOutlined
                                  color="red"
                                  size={20}
                                  onClick={() => {
                                    setVisible(true);
                                  }}
                                />
                              ) : (
                                <PlusOutlined />
                              )
                            }
                          >
                            <GetLabel label="addInvoice" />
                          </Button>
                        )}
                        title="addInvoice"
                      >
                        <InvoiceWizardMain
                          setVisible={setVisible}
                          initialData={{
                            codeClientFacture:
                              thirdPartyData?.generalData?.tpreference || '',
                          }}
                          onSave={(conformityRequest, response) => {
                            // Callback quand la facture est créée avec succès

                            console.log('Facture créée:', response);

                            refetch(); // Recharger la liste des contrats

                            setVisible(false);
                          }}
                          onError={(error) => {
                            // Callback en cas d'erreur

                            console.error('Erreur création facture:', error);
                          }}
                        />
                      </ModalSFS>
                    </Col>
                  </Row>
                ) : (
                  <Col>
                    <ModalSFS
                      trigger={({ setVisible }) => (
                        <Button
                          className={
                            rowCount !== 0
                              ? 'no-border-radius filter-item ant-btn-outline-primary bg-color-hover'
                              : 'no-border-radius filter-item'
                          }
                          onClick={() => !isInspect && setVisible(true)}
                          disabled={!isInspect}
                          icon={<EuroOutlined />}
                        >
                          <GetLabel label={'progPayment'} />
                        </Button>
                      )}
                      title="progPayment"
                    >
                      <PaymentModal
                        mode="create"
                        source="encours"
                        data={selectedRows}
                        setVisible={() => setVisible(false)}
                        setmodalVisibleConfirmVisible={() =>
                          setmodalVisibleConfirmVisible(true)
                        }
                      />
                    </ModalSFS>
                  </Col>
                )}

                <Col span={5} className="d-flex justify-end align-center">
                  <ExportXLS
                    data={fincontractData || []}
                    filename="outsanding-activities"
                    columns={colsXLS}
                  />
                </Col>
              </Row>

              <Row className="align-center">
                <Col span={24}>
                  <Form.Item name="filteredData" initialValue={fincontractData}>
                    <DataGrid
                      columns={tptype === 'CONC' ? columns : Activitycolumns}
                      dataSource={fincontractData || []}
                      className="custom-data-grid"
                      rowKey="ctrid"
                      size="large"
                      rowSelection={{
                        type: 'checkbox',

                        onChange: (selectedRowKeys, selectedRows) => {
                          setSelectedRows(selectedRows);

                          form.setFieldsValue({ selectedRows: selectedRows });
                        },

                        hideSelectAll: false,

                        columnWidth: 80,
                      }}
                      pagination={{
                        pageSize: 10,

                        showSizeChanger: true,

                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} sur ${total}`,
                      }}
                      scrollInput={{ x: 1000, y: 550 }}
                      isLoading={isFetching}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </>
        ) : selectedContract ? (
          <ContractDetail
            onPrev={back}
            clientName={selectedContract?.clientname} // Ensure it’s not undefined
            form={form}
            color={color || 'purple'}
            tpauthid={tpauthid}
          />
        ) : (
          <div>Loading...</div>
        )}

        <ConfirmModal
          className="modalConfirmOrCancel"
          visible={modalVisibleConfirm}
          status="progress"
          message="Demande envoyée !"
          description="Votre demande est en cours de traitement.Vous serez notifié après décision."
          onConfirm={() => {
            setmodalVisibleConfirmVisible(false);
          }}
          onSeeMore={() => {}}
          Confirmcomcode="close"
          SeeMorecomcode="seemyrequest"
          onlyConfirm
          onlySeeMore
        />
      </Form>
    </DisplayFramework.Provider>
  );
};

export default ContractSubTab;
